import { render, staticRenderFns } from "./pay-code.vue?vue&type=template&id=5df389ba&scoped=true&"
import script from "./pay-code.vue?vue&type=script&lang=js&"
export * from "./pay-code.vue?vue&type=script&lang=js&"
import style0 from "./pay-code.vue?vue&type=style&index=0&id=5df389ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df389ba",
  null
  
)

export default component.exports